export const MAIN_REDIRECT = 'MAIN_REDIRECT'